import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Withdraw = {
  withdraw_id?: number; // 출금 idx
  settlement_amount_id?: number; // 정산 idx
  application_price?: number; // 신청금액
  withdrawal_method?: string; // 출금 방법
  deposit_account_number?: string; // 입금 계좌번호
  etc?: string; // 비고
  withdraw_status?: string;
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Withdraw
   * --
   */
  getWithdraws: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_WITHDRAW, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Withdraw
   * --
   */
  getWithdraw: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_WITHDRAW, {
        withdraw_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Withdraw
   * --
   */
  createWithdraw: async (body: Withdraw) => {
    try {
      const res = await $http.post(APIConstant.CREATE_WITHDRAW, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Withdraw
   * --
   */
  updateWithdraw: async (body: Withdraw) => {
    try {
      const { withdraw_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_WITHDRAW, {
        withdraw_id: withdraw_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Withdraw
   * --
   */
  deleteWithdraw: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_WITHDRAW, {
        withdraw_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Withdraw
   * --
   */
  upsertWithdraw: async (body: Withdraw[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_UPSERT_WITHDRAW,
        body,
        'PUT'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
